export const PAGE_SIZE = 10;
export const dayMap = { '일': 0, '월': 1, '화': 2, '수': 3, '목': 4, '금': 5, '토': 6 };
export const PLACEHOLDER_URL = 'https://lh3.googleusercontent.com/a/ACg8ocKfHv1TrOdvwEo5bp2SW96PrKvwkGU6vDmpm6n75QX-IexhTw=s96-c';
export const typeColors = {
  '게임': '#b16800',
  '레슨': 'red',
  '대회': 'gold',
  '정모': '#00ff80',
  '용품': '#2196f3'
};

export const gameTypes = ['남성 단식', '여성 단식', '남성 복식', '여성 복식', '혼합 복식'];
export const tournamentCategories = ['남복', '여복', '혼복', '남단', '여단', '단체전'];
export const tournamentOrganizers = ['KATO', 'KATA', 'KTA', '용테협', '던롭', 'WEMIX'];
export const katoDivisions = ['국화부', '개나리부', '베테랑부', '마스터스부', '챌린저부', '퓨처스부', '혼합복식부', '지역신인부', '지도자부'];
export const kataDivisions = ['국화부', '개나리부', '베테랑부', '오픈부', '신인부', '장년부', '청년부', '지도자부'];
export const ktaDivisions = ['국화부', '개나리부', '베테랑부', '전국신인부', '지역신인부', '남자오픈부', '세미오픈부', '지도자부'];
export const yonginDivisions = ['지역신인부', '시니어부', '국화부', '개나리부', '에이스부단체전', '금배부단체전', '은배부단체전', '동배부단체전'];
export const dxoDivisions = ['복식', '브론즈', '실버'];
export const wemixDivisions = ['동호인클럽매치', '캠퍼스남자단체전', '캠퍼스여자단체전', '캠퍼스레전드매치'];